import 'waypoints/lib/noframework.waypoints.min.js';
import Gumshoe from 'gumshoejs';

class PageNav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.toggle = self.elem.querySelector('[data-page-nav-toggle]');
        self.items = self.elem.querySelectorAll('[data-page-nav-item]');
        self.onOutsideClick = self.onOutsideClick.bind(self);
        self.onEscape = self.onEscape.bind(self);
        self.isOpen = false;
    }

    init() {
        let self = this;

        self.toggle.addEventListener('click', evt => {
            if(self.isOpen) {
                self.close();
            } else {
                self.open();
            }
        });

        [...self.items].map(item => {
            // Get the page section that corresponds to this item
            let section = document.getElementById(item.getAttribute('href').replace('#', ''));

            // Close the dropdown when an item is clicked
            item.addEventListener('click', evt => {
                self.close();
            });
        });

        // Scrollspy - highlight the nav item when its corresponding section is in view
        const spy = new Gumshoe('[data-page-nav-item]', {
            offset: function () {
                return window.getComputedStyle(document.documentElement).getPropertyValue('--scroll-padding-top');
            }
        });

        // Listen for changes to the currently active nav item
        document.addEventListener('gumshoeActivate', (evt) => {
            // Get the textContent of the currently active item
            let linkText = evt.detail.link.textContent;
            // Update the dropdown toggle text
            self.toggle.textContent = linkText;
        });
        
        // Stickyness
        let waypoint = new Waypoint({
            element: self.elem,
            offset: window.getComputedStyle(document.documentElement).getPropertyValue('--scroll-padding-top'),
            handler: function(direction) {
                if(direction === 'down') {
                    self.elem.classList.add('is-stuck');
                } else {
                    self.elem.classList.remove('is-stuck');
                }
            }
        });
    }

    open() {
        let self = this;

        self.elem.classList.add('is-open');
        self.toggle.setAttribute('aria-expanded', true);

        self.isOpen = true;
        
        // Add event listeners
        self.addEventListeners();
    }

    close() {
        let self = this;

        self.elem.classList.remove('is-open');
        self.toggle.setAttribute('aria-expanded', false);

        self.isOpen = false;
        
        // Remove event listeners
        self.removeEventListeners();
    }

    addEventListeners() {
        let self = this;

        // Start listening for clicks outside the dropdown
        document.addEventListener('click', self.onOutsideClick);

        // Start listening for escape key press
        document.addEventListener('keydown', self.onEscape);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for clicks outside the dropdown
        document.removeEventListener('click', self.onOutsideClick);

        // Stop listening for escape key press
        document.removeEventListener('keydown', self.onEscape);
    }

    onOutsideClick(evt) {
        let self = this;

        // If the click was not on the dropdown or its children
        // or the open button or its children
        if (evt.target !== self.elem && !self.elem.contains(evt.target)) {

            // Close the dropdown
            self.close();
        }
    }

    onEscape(evt) {
        let self = this;

        if (evt.key === "Escape") {
            self.close();
        }
    }
}

export default PageNav;
